import { Fragment } from 'react';

export const Header = () => {
    return (

        <Fragment>
            <img
                src={`BitposLogo.png`}
                alt="some alt"
                loading="lazy"
                style={{ maxWidth: "15em", margin: "0.5em 0 1em 0" }}
            />
        </Fragment>
    );
}